export const FAVORITE_SYSTEM = 'http://lifeomic.com/fhir/favorite-resource';
export const LEGACY_FAVORITE_SYSTEM = 'www.lifeomic.com/fhir/favorite-resource';

export const upsertFavoriteSystem = (
  resource: fhir.DomainResource,
): fhir.DomainResource => ({
  ...resource,
  meta: {
    ...(resource.meta || {}),
    tag: [
      ...(resource.meta?.tag || []).filter(_ => _.system !== FAVORITE_SYSTEM),
      {
        system: FAVORITE_SYSTEM,
      },
    ],
  },
});

export const removeFavoriteSystem = (resource: fhir.DomainResource) => {
  const newResource = {
    ...resource,
    meta: {
      ...(resource.meta || {}),
      tag: (resource.meta?.tag || []).filter(
        _ =>
          _.system !== FAVORITE_SYSTEM && _.system !== LEGACY_FAVORITE_SYSTEM,
      ),
    },
  };

  if (newResource.meta?.tag?.length === 0) {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    delete newResource.meta.tag;
  }

  if (Object.keys(newResource.meta || {}).length === 0) {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    delete newResource.meta;
  }

  return newResource;
};

export const getIsFavorite = (resource: fhir.DomainResource) =>
  (resource.meta?.tag || []).some(_ =>
    [FAVORITE_SYSTEM, LEGACY_FAVORITE_SYSTEM].includes(_.system || ''),
  );
